import React, { useMemo } from "react";
import { ZustandStore } from "../../../store/zustand-store";
import dayjs from "dayjs";
import {
  addLocationToData,
  filterAndSortData,
  filterUndefinedFromArray,
  findByFormattedDate,
} from "../../../helperJs/helper";

const useDateRangeData = () => {
  const { selected_rank_data, selected_date } = ZustandStore((state) => state);

  const dateRangeData = useMemo(() => {
    if (selected_rank_data?.data?.length === 0 || !selected_date) return [];
    // Formatting dates using dayjs
    const formattedFromDate = dayjs(selected_date?.from).format("DD MMM YYYY");
    const formattedToDate = dayjs(selected_date?.to).format("DD MMM YYYY");
    const selected_data = selected_rank_data?.data?.map((item) => {
      const from = findByFormattedDate(item.data, formattedFromDate);
      const to = findByFormattedDate(item.data, formattedToDate);
      return {
        data: filterAndSortData(
          item.data,
          selected_date.from,
          selected_date.to
        ),
        location_name: item.location,
        from_data: addLocationToData(from?.data, from?.location),
        to_data: addLocationToData(to?.data, to?.location),
      };
    });

    const data = selected_data?.flatMap((item) => {
      const arr = item.data;
      return arr.map((obj) => {
        return {
          ...obj,
          location_name: item.location_name,
        };
      });
    });

    const combineFromData = selected_data?.flatMap((item) => {
      return item.from_data;
    });
    const combineToData = selected_data?.flatMap((item) => {
      return item.to_data;
    });
    return {
      data,
      from_data: filterUndefinedFromArray(combineFromData),
      to_data: filterUndefinedFromArray(combineToData),
    };
  }, [selected_date, selected_rank_data]);

  return dateRangeData;
};

export default useDateRangeData;
